import { connect } from 'react-redux';
import { update } from '../../../store/auth';
import { subscriptionActions } from '../../../store/subscription';

function mapStateToProps(state) {
  return {
    authUser: state.auth || {},
    subscription: state.subscription,
    userRole: state.orgSettings?.userRole,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateOnViewHelpUseNotifications: (params) => dispatch(update(params)),
    setOpenModalPremium: (payload) => dispatch(subscriptionActions.setOpenModalPremium(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps);
